export const policy = `
<p><strong>ข้อกำหนดและเงื่อนไข</strong></p>

<p><strong>1. ประเภทข้อมูลส่วนบุคคล</strong></p>

<p>&middot; <u>ข้อมูลทั่วไป </u>หมายความว่า ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ</p>

<p>&middot; <u>ข้อมูลด้านการทำธุรกรรม</u> หมายความว่า ข้อมูลหรือสิ่งใดๆที่แสดงออกมาในรูปแบบเอกสาร แฟ้ม รายงาน หนังสือ แผนผัง แผนที่ ภาพวาด ภาพถ่าย ฟิล์ม การบันทึกภาพนิ่ง การบันทึกภาพเคลื่อนไหว เสียงการบันทึก โดยเครื่องมือทางอิเล็กทรอนิกส์ หรือวิธีอื่นใดๆ ที่ทำให้สั่งที่บันทึกไว้ปรากฎขึ้นในเรื่องที่เกี่ยวกับการดำเนินธุรกิจ ของบุคคลที่สามารถระบุตัวบุคคลได้</p>

<p>&nbsp;</p>

<p><strong>2. วัตถุประสงค์การเก็บ รวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล</strong></p>

<p>ในการเก็บรวบรวม ใช้ และประมวลผล ข้อมูล ส่วนบุคคล สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม ดำเนินการเพื่อวัตถุประสงค์ ดังต่อไปนี้</p>

<p>&middot; เพื่อประมวลผล และบริหารจัดการตามหน้าที่ของสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัย และนวัตกรรม</p>

<p>&middot; เพื่อใช้ข้อมูลในการวิเคราะห์ เสนอ ให้ ใช้ และ/หรือปรับปรุงบริการ หรือข้อกำหนดหลักสูตรต่างๆ</p>

<p>&middot; ที่เกี่ยวข้องกับอำนาจหน้าที่ของสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม</p>

<p>&middot; เพื่อปรับปรุงการให้บริการของสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม</p>

<p>&middot; เพื่อปฏิบัติตามข้อบังคับของกฎหมาย</p>

<p>&middot; เพื่อการดำเนินการใดๆ ที่เกี่ยวข้องโดยตรงตามที่กล่าวมาข้างต้น</p>

<p>&nbsp;</p>

<p><strong>3. แหล่งที่มาของข้อมูลส่วนบุคคล</strong></p>

<p><u>ข้อมูลจากเจ้าของโดยตรง</u></p>

<p>&middot; ข้อมูลส่วนบุคคล รวมถึงเอกสารประกอบและข้อมูลการสื่อสารต่างๆ เช่น สำเนาบัตรประจำตัวประชาชน สำเนาทะเบียนบ้าน ฯลฯ ที่เจ้าของข้อมูลส่วนบุคคลได้มอบให้กับสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม ในรูปแบบหนังสือหรือวิธีการทางอิเล็กทรอนิกส์</p>

<p>&middot; ข้อมูลส่วนบุคคลที่เจ้าของข้อมูลส่วนบุคคลให้ไว้ในการติดต่อสื่อสารทางอิเล็กทรอนิกส์ หรือกิจกรรมต่าง ๆ ของสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม เช่น กิจกรรมงานประกวดรางวัลนวัตกรรมแห่งประเทศไทย เป็นต้น</p>

<p><u>ข้อมูลจากแหล่งอื่น</u></p>

<p>&middot; ข้อมูลจากหน่วยงานในสังกัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม</p>

<p>&middot; ข้อมูลจากการบูรณาการร่วมกันระหว่างหน่วยงานภาครัฐ ทั้งนี้ เพื่อประโยชน์ในการปรับปรุงข้อมูลส่วนบุคคลให้เป็นปัจจุบัน และเพื่อปรับปรุงคุณภาพและประสิทธิภาพการให้บริการของสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมให้ดียิ่งขึ้น</p>

<p>&nbsp;</p>

<p><strong>4. ระยะเวลาในการเก็บรวบรวมข้อมูลส่วนบุคคล</strong></p>

<p>สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม จะเก็บรักษาข้อมูลส่วนบุคคลตราบเท่า ที่จำเป็นต่อการประมวลผล ตามวัตถุประสงค์ในการดำเนินงานของสำนักงานปลัดกระทรวง การอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมเท่านั้น และจะจัดให้มีการตรวจสอบเพื่อดำเนินการลบหรือทำลายข้อมูลส่วน บุคคลเมื่อพ้นกำหนดระยะเวลาการเก็บรักษา</p>

<p>&nbsp;</p>

<p><strong>5. การเปิดเผยข้อมูลส่วนบุคคล</strong></p>

<p>สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม จะเปิดเผยข้อมูลส่วนบุคคล ตามหน้าที่ และอำนาจของสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม หรือตามวัตถุประสงค์ที่ ได้แจ้งไว้กับเจ้าของข้อมูลส่วนบุคคลเท่านั้น กรณีมีการบังคับให้เปิดเผยข้อมูลส่วนบุคคลตามกฎหมาย หรือคำสั่ง ศาล/หมายศาล สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม ต้องดำเนินการตามข้อ บังคับดังกล่าว</p>

<p>&nbsp;</p>

<p><strong>6. การส่งหรือการโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ</strong></p>

<p>กรณีส่ง โอน หรือให้บุคคลอื่นใช้ข้อมูลส่วนบุคคล สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและ นวัตกรรมจะทำข้อตกลงกับผู้รับหรือใช้ข้อมูลส่วนบุคคลนั้น เพื่อกำหนดสิทธิและหน้าที่ในการใช้ข้อมูลส่วนบุคคล ให้สอดคล้องตามวัตถุประสงค์ที่ได้แจ้งไว้กับเจ้าของข้อมูลส่วนบุคคล หากผู้รับหรือใช้ข้อมูลส่วนบุคคล อยู่ต่าง ประเทศ หน่วยงานปลายทางต้องมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่เพียงพอ เว้นแต่ได้รับ ความยินยอม จากเจ้าของข้อมูลส่วนบุคคล หรือมีกฎหมายหรือความร่วมมือระหว่างประเทศให้ส่ง โอน หรือให้บุคคลอื่นภาย นอกประเทศใช้ข้อมูลส่วนบุคคลได้โดยไม่ต้องได้รับความยินยอมจากเจ้าของข้อมูลส่วนบุคคล</p>

<p>&nbsp;</p>

<p><strong>7. สิทธิของเจ้าของข้อมูลส่วนบุคคล</strong></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิในการดำเนินการ ดังต่อไปนี้</p>

<p><u>&middot; สิทธิในการเพิกถอนความยินยอม (right to withdraw consent)</u></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่เจ้าของข้อมูลส่วน บุคคลได้ให้ความยินยอมไว้แก่สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมได้ ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของตนอยู่กับสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและ นวัตกรรม</p>

<p><u>&middot; สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (right of access)</u></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิเข้าถึงข้อมูลส่วนบุคคลของตนและขอให้สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่เจ้าของข้อมูลส่วนบุคคล รวมถึงขอให้ สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมเปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคลที่ เจ้าของข้อมูลส่วนบุคคลไม่ได้ให้ความยินยอมต่อสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและ นวัตกรรมได้</p>

<p><u>&middot; สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (right to rectification)</u></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิขอให้สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม แก้ไขข้อมูลส่วนบุคคลที่ไม่ถูกต้อง หรือเพิ่มเติมข้อมูลส่วนบุคคลที่ไม่สมบูรณ์</p>

<p><u>&middot; สิทธิในการลบข้อมูลส่วนบุคคล (right to erasure)</u></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิในการขอให้สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและ นวัตกรรม ทำการลบข้อมูลส่วนบุคคลของตนด้วยเหตุบางประการได้ หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่ สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้</p>

<p><u>&middot; สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (right to restriction of processing)</u></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิระงับการใช้ข้อมูลส่วนบุคคลของตนด้วยเหตุบางประการได้</p>

<p><u>&middot; สิทธิในการให้โอนย้ายข้อมูลส่วนบุคคล (right to data portability)</u></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิให้สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมโอน ย้ายข้อมูลส่วนบุคคลซึ่งเจ้าของข้อมูลส่วนบุคคลได้ให้ไว้กับสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมไปยังผู้ควบคุมข้อมูลส่วนบุคคลรายอื่น หรือตัวเจ้าของข้อมูลส่วนบุคคลเองด้วยเหตุบาง ประการได้</p>

<p><u>&middot; สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (right to object)</u></p>

<p>เจ้าของข้อมูลส่วนบุคคลมีสิทธิคัดค้านการประมวลผลข้อมูลส่วนบุคคลของตนด้วยเหตุบางประการได้</p>

<p>&nbsp;</p>

<p><strong>8. วิธีการเพิกถอนความยินยอมและผลการเพิกถอนความยินยอม</strong></p>

<p>ความยินยอมที่เจ้าของข้อมูลส่วนบุคคลให้ไว้กับสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและ นวัตกรรมในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลยังคงใช้ได้จนกว่าเจ้าของข้อมูลส่วนบุคคลจะเพิก ถอนความยินยอมเป็นลายลักษณ์อักษร โดยเจ้าของข้อมูลส่วนบุคคลสามารถเพิกถอนความยินยอมหรือระงับ การใช้หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ในการดำเนินกิจกรรมใด ๆ หรือทุกกิจกรรมของสำนักงาน ปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม</p>

<p>เจ้าของข้อมูลส่วนบุคคลสามารถเพิกถอนความยินยอมได้ โดยยื่นคำร้องขอใช้สิทธิตามแบบฟอร์มที่สำนักงาน ปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมกำหนด ผ่าน &ldquo;ช่องทางการติดต่อสื่อสาร&rdquo; ตามข้อ 9 โดยสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมจะแจ้งผลการพิจารณาคำร้องขอ ใช้สิทธิไปยังเจ้าของข้อมูลส่วนบุคคล ทั้งนี้สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัต กรรม อาจปฏิเสธสิทธิของเจ้าของข้อมูลส่วนบุคคล ในกรณีที่เป็นการปฏิเสธตามกฎหมายหรือคำสั่งศาล</p>

<p>&nbsp;</p>

<p>9. ช่องทางการติดต่อสื่อสาร เจ้าของข้อมูลส่วนบุคคลสามารถติดต่อสำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม ได้ตามช่องทางดังต่อไปนี้</p>

<p>ที่อยู่: สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม 75/47 อาคารพระจอมเกล้า ถ.พระราม 6 แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพฯ 10400 : 328 อาคารอุดมศึกษา 1,2 ถ.ศรีอยุธยา แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพฯ 10400</p>

<p>อีเมล: stdb@mhesi.go.th</p>

<p>โทร: 02-333-3943</p>
`;
